import store from 'redux-store/store';
import { isRunningTest } from 'utils/platform';

import { DoorHeightEnum } from 'CoreAPI/Components/DoorHeightEnum';
import { Vector } from '@inter-ikea-core/core';
import { CORE_TO_VIEWER_SCALE } from 'utils/constants';

export const DefaultRoomSettings = {
  ROOM_WIDTH_M: 2.0,
  ROOM_HEIGHT_M: 2.4,
  ROOM_HEIGHT_LOW_DOORS_ONLY_M: 2.04,
  ROOM_DEPTH_M: 5
};

export const getDefaultRoomHeight = () => {
  if (isRunningTest) {
    return DefaultRoomSettings.ROOM_HEIGHT_M;
  }

  if (!store.getState().products.doorHeightOptionsAvailable.length) {
    return DefaultRoomSettings.ROOM_HEIGHT_M;
  }

  return store.getState().products.doorHeightOptionsAvailable.includes(DoorHeightEnum.High)
    ? DefaultRoomSettings.ROOM_HEIGHT_M
    : DefaultRoomSettings.ROOM_HEIGHT_LOW_DOORS_ONLY_M;
};

export const defaultRoomSize = new Vector(
  DefaultRoomSettings.ROOM_WIDTH_M * CORE_TO_VIEWER_SCALE,
  getDefaultRoomHeight() * CORE_TO_VIEWER_SCALE,
  DefaultRoomSettings.ROOM_DEPTH_M * CORE_TO_VIEWER_SCALE
);
